package songwritersnotebook.app.database

import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import songwritersnotebook.app.utils.SnBridge
import songwritersnotebook.database.AppDatabase

actual class DatabaseDriverFactory {
    actual suspend fun createDriver(): SqlDriver {
        val driver = WebWorkerDriver(
            SnBridge.createSqlWorker()
        )
        try {
            AppDatabase.Schema.create(driver).await()
        } catch (e: Exception) {
            println("DatabaseDriverFactory: Schema create failed (likely already exists): $e")
        }
        return driver
    }
}
